//import { Navigation } from '@shopify/polaris';
import { Outlet } from 'react-router-dom';
const PublicLayout = () => {
  return (
    <Outlet />
  )
}

export default PublicLayout;